import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../../routers/constants'

const COMPANY_NAME_MAX_WIDTH = 400

const BaseCell = ({ val, rowId, colId }) => {
  const redirect = () => {
    if (colId === 'taxCode') return
    const url = `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${rowId}`
    window.open(url, '_blank').focus()
  }

  return (
    <div onClick={redirect} style={{ maxWidth: COMPANY_NAME_MAX_WIDTH }}>
      <TextEllipsisStaticLine text={val} isI18n={false} />
    </div>
  )
}

export default BaseCell
